import { createFileRoute } from "@tanstack/react-router";
import { InitiativesPage } from "@/features/initiatives/InitiativesPage";

export const Route = createFileRoute("/_app/initiatives/")({
  component: () => <InitiativesPage />,
});
